import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, cloneElement } from 'react';
import Box from '../Box';
export var TABPANELS_DISPLAY_NAME = 'TabPanels';

var TabPanels = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TabPanels, _Component);

  function TabPanels() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TabPanels.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        activeIndex = _this$props.activeIndex,
        children = _this$props.children,
        id = _this$props.id,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["activeIndex", "children", "id"]);

    var child = children[activeIndex];
    return /*#__PURE__*/React.createElement(Box, restProps, child ? /*#__PURE__*/cloneElement(child, {
      activeId: id + "-" + activeIndex
    }) : null);
  };

  return TabPanels;
}(Component);

_defineProperty(TabPanels, "displayName", TABPANELS_DISPLAY_NAME);

export default TabPanels;